type RuntimeConfig = {
  relayWsUrl?: unknown;
  relayWsUrls?: unknown;
  videoWorkerDecode?: unknown;
  videoFineMetrics?: unknown;
  videoWebGpuRender?: unknown;
  videoH265Default?: unknown;
  videoCodecPolicy?: unknown;
  e2eEncryption?: unknown;
  muxBrowser?: unknown;
};

type RuntimeWindow = Window & {
  __remotews_config__?: RuntimeConfig;
  __remotews_relay_ws_url__?: string;
  __remotews_relay_ws_urls__?: string[];
  __remotews_video_worker_decode__?: boolean;
  __remotews_video_fine_metrics__?: boolean;
  __remotews_video_webgpu_render__?: boolean;
  __remotews_video_h265_default__?: boolean;
  __remotews_video_codec_policy__?: boolean;
  __remotews_e2e_encryption__?: boolean;
};

function runtimeWindow(): RuntimeWindow {
  return window as RuntimeWindow;
}

export function applyRuntimeConfig(cfg: RuntimeConfig | null | undefined): void {
  if (!cfg || typeof cfg !== "object") return;
  const w = runtimeWindow();
  w.__remotews_config__ = cfg as RuntimeConfig;
  if (typeof cfg.relayWsUrl === "string" && cfg.relayWsUrl.length > 0) {
    w.__remotews_relay_ws_url__ = cfg.relayWsUrl;
  }
  if (Array.isArray(cfg.relayWsUrls) && cfg.relayWsUrls.length > 0) {
    const list = cfg.relayWsUrls.filter((u): u is string => typeof u === "string" && u.length > 0);
    if (list.length > 0) w.__remotews_relay_ws_urls__ = list;
  }
  if (cfg.videoWorkerDecode === true) w.__remotews_video_worker_decode__ = true;
  if (cfg.videoFineMetrics === true) w.__remotews_video_fine_metrics__ = true;
  if (cfg.videoWebGpuRender === true) w.__remotews_video_webgpu_render__ = true;
  if (cfg.videoH265Default === true) w.__remotews_video_h265_default__ = true;
  if (cfg.videoCodecPolicy === true) w.__remotews_video_codec_policy__ = true;
  if (cfg.e2eEncryption === true) w.__remotews_e2e_encryption__ = true;
}

export async function refreshRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch("/config.json", { credentials: "same-origin", cache: "no-store" });
    if (!res.ok) return;
    applyRuntimeConfig((await res.json()) as RuntimeConfig);
  } catch {
    /* silencieux : fallback sur l'origine courante */
  }
}
